<script lang="ts">
	import Icon from '../Icon/Icon.svelte'
	import type { IconName } from '../../svg-icons/iconsMap.ts'
	import { BADGE_DOT_CONFIG, BadgeDotSize, BadgeDotType } from './constants.ts'

	type Props = {
		type?: BadgeDotType
		size?: BadgeDotSize
		showIcon?: boolean
		icon?: IconName | null
		backgroundColor?: string
		color?: string
		ariaLabel?: string
		title?: string
		spinning?: boolean
		class?: string
	}

	let {
		type = BadgeDotType.ONLINE,
		size = BadgeDotSize.LARGE,
		showIcon = true,
		icon,
		backgroundColor,
		color,
		ariaLabel,
		title,
		spinning = false,
		class: className = ''
	}: Props = $props()

	const config = $derived(BADGE_DOT_CONFIG[type])

	const resolvedIcon = $derived(
		size === BadgeDotSize.SMALL || icon === null ? undefined : (icon ?? config.icon)
	)

	const dotStyle = $derived(
		`--badge-dot-bg:${backgroundColor ?? config.backgroundColor};--badge-dot-color:${color ?? config.color}`
	)
</script>

<span
	class={`badge-dot badge-dot--${size} ${className}`}
	style={dotStyle}
	aria-label={ariaLabel}
	{title}
	role={ariaLabel ? 'img' : undefined}
>
	{#if showIcon && resolvedIcon}
		<Icon
			name={resolvedIcon}
			size={size === BadgeDotSize.LARGE ? 'xs' : 'xxs'}
			class={spinning ? 'animate-spin' : ''}
			aria-label={ariaLabel}
		/>
	{/if}
</span>

<style lang="postcss">
	.badge-dot {
		background: var(--badge-dot-bg);
		color: var(--badge-dot-color);

		@apply inline-flex flex-shrink-0 items-center justify-center rounded-full;
	}

	.badge-dot--small {
		@apply h-2 w-2;
	}

	.badge-dot--medium {
		@apply h-3 w-3;
	}

	.badge-dot--large {
		@apply h-4 w-4;
	}
</style>
